/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Kn_OkInputs */

const cs_property_lustrace_kn_ok = /** @type {(inputs: Property_Lustrace_Kn_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katastr načten`)
};

const en_property_lustrace_kn_ok = /** @type {(inputs: Property_Lustrace_Kn_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre loaded`)
};

/**
* | output |
* | --- |
* | "Cadastre loaded" |
*
* @param {Property_Lustrace_Kn_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_kn_ok = /** @type {((inputs?: Property_Lustrace_Kn_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Kn_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_kn_ok(inputs)
	return cs_property_lustrace_kn_ok(inputs)
});